import React from "react";
import "./ongoing.scss";

const Ongoing = () => {
  return (
    <div className="WrapperSession">
      <div className="top">
        <p>icon 2 participants</p>
      </div>
      <h3>Testing</h3>
      <div className="down">
        <h3>Aayush Shukla</h3>
        <div className="try">
          <button>Join Now</button>
        </div>
      </div>
    </div>
  );
};

export default Ongoing;
